import cloneDeep from 'lodash.clonedeep'

import { navigate } from '@redwoodjs/router'

import { defaultFilters } from '../components/FiltersSiderbar/Filters'
import { SelectedFilter } from '../components/SelectedFiltersBar/SelectedFiltersBar'
import { ApplicantFiltersActionType } from '../context/applicant-filters.reducer'

// Helper function to ensure filters have complete structure before saving
export const ensureCompleteFilterStructure = (inputFilters) => {
  const normalizedFilters = cloneDeep(inputFilters)

  // Ensure applicantStages has complete structure
  if (normalizedFilters.applicantStages) {
    if (
      !normalizedFilters.applicantStages.key ||
      !normalizedFilters.applicantStages.type ||
      !normalizedFilters.applicantStages.title
    ) {
      normalizedFilters.applicantStages = {
        ...normalizedFilters.applicantStages,
        key: 'applicantStages',
        type: 'applicant-stage-filter',
        title: 'Applicant Stage',
      }
    }
    // Ensure options array exists
    if (!normalizedFilters.applicantStages.options) {
      normalizedFilters.applicantStages.options =
        defaultFilters.applicantStages.options
    }
  }

  return normalizedFilters
}

export const onRemoveSelectedFilter = (
  filter: SelectedFilter,
  {
    dispatchFilters,
    searchTextSet,
    setSelectedPresetId,
    setSelectedPresetFilter,
    selectedPresetFilter,
  }
) => {
  const multiSelectFilters = {
    recruiters: 1,
    jobListings: 1,
    leadSources: 1,
    endorsements: 1,
    states: 1,
    tags: 1,
    equipmentTypes: 1,
    eligibleForHire: 1,
    permanentlyDisqualified: 1,
    taskDeadline: 1,
    taskAssignees: 1,
    taskTemplates: 1,
  }
  const rangeFilters = {
    taskDueDate: 1,
    applicationDate: 1,
    lastContactDate: 1,
    availableForWorkDate: 1,
    hiredDate: 1,
    terminatedDate: 1,
    disqualifiedDate: 1,
    notInterestedDate: 1,
    bookingDate: 1,
    yearsOfExperience: 1,
    callCount: 1,
    missedOutboundCallCount: 1,
  }

  if (multiSelectFilters[filter.key]) {
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAN_MULTI_SELECT,
      payload: filter,
    })
  }

  if (
    multiSelectFilters[filter.key] &&
    filter.key === 'hiringStages' &&
    selectedPresetFilter
  ) {
    setSelectedPresetId(null)
    setSelectedPresetFilter(null)
  }

  if (filter.key === 'searchText') {
    searchTextSet('')
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAN_SEARCHBOX,
    })
  }
  if (rangeFilters[filter.key]) {
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAN_RANGE_FILTER,
      payload: {
        filterKey: filter.key,
      },
    })
  }
  if (filter.key.startsWith('steps')) {
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAN_STEP_FILTER,
      payload: filter,
    })
  }
  if (filter.key.startsWith('applicantStages')) {
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAR_APPLICANT_STAGE_FILTER,
      payload: filter,
    })
  }
  if (filter.key === 'zipCodes') {
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAN_ZIPCODE_FILTER,
      payload: filter,
    })
  }
  if (filter.key.startsWith('customField-')) {
    // Extract customFieldId from the key (format: "customField-<customFieldId>")
    const customFieldId = filter.value // We stored customFieldId in the value field
    dispatchFilters({
      type: ApplicantFiltersActionType.CLEAR_CUSTOM_FIELD,
      payload: customFieldId,
    })
  }
}

export const onClearFilters = (searchTextSet, dispatchFilters) => {
  // Keep the preset selected so cleared state gets auto-saved
  searchTextSet('')
  dispatchFilters({
    type: ApplicantFiltersActionType.CLEAR_ALL,
  })
}

export const reset = (
  setSelectedPresetId,
  setSelectedPresetFilter,
  dispatchFilters,
  navigate
) => {
  // Clear the preset selection BEFORE clearing filters to prevent auto-save
  setSelectedPresetId(null)
  setSelectedPresetFilter(null)

  // Remove view parameters from URL
  const searchParams = new URLSearchParams(window.location.search)
  searchParams.delete('viewId')
  searchParams.delete('view')
  navigate(`?${searchParams.toString()}`, { replace: true })

  dispatchFilters({
    type: ApplicantFiltersActionType.FILTERS_CHANGED,
    payload: defaultFilters,
  })
}
